export const AREA_BREADTH = 32;
